import { useEffect, useState } from 'react';
import { Avatar, Pagination, Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useSelector } from 'react-redux';
import { useGetApiRequests } from '../../../common/CommonExport';

import ManageLeaveModal from './modal/ManageLeaveModal';
import { getBalancveLeaveList } from './helper/ManageLeaveHelper';

interface EmployeeRecord {
  employeeId: string;
  firstName: string;
  lastName: string;
  employeeName: string;
  sickLeaveBalance: number;
  casualLeaveBalance: number;
  earnedLeaveBalance: number;
  permissionLeaveBalance: number;
  totalLeaves: number;
  employeeCode: string;
}

interface ManageLeaveTableProps {
  searchQuery: string;
}

const ManageLeaveTable: React.FC<ManageLeaveTableProps> = ({ searchQuery }) => {
  const getBalanceLeaveApi = useGetApiRequests('getBalanceLeave', 'GET');
  const [loader, setLoader] = useState(false);
  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [leaveDataList, setLeaveDataList] = useState<EmployeeRecord[]>([]);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [editRecord, setEditRecord] = useState<EmployeeRecord | null>(null);
  const [count, setCount] = useState<number>(0);

  const onShowSizeChange = (current: number, newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };
  useEffect(() => {
    const tags = document.getElementsByClassName('ant-table-content')
    tags[1].scrollTop = 0
    getManageLeaveList("", 0, 10)
  }, [])
  useEffect(() => {
    const tags = document.getElementsByClassName('ant-table-content')
    tags[1].scrollTop = 0;
    if (searchQuery === "" && currentPage !== 0) {
      let searchIndex = currentPage - 1;
      getManageLeaveList(searchQuery, searchIndex * 10, pageSize);

    } else {
      setCurrentPage(1);
      getManageLeaveList(searchQuery, 0, pageSize);

    }
  }, [searchQuery])
  const getManageLeaveList = (searchTerm = '', currentPage?: number, pageSize?: number) => {
    getBalancveLeaveList({ setLoader, currentPage, pageSize, orgId, searchQuery, searchTerm, getBalanceLeaveApi, setLeaveDataList, setCount })
  };

  const getLeaveType = (fullName: string): string => {
    const words = fullName?.split(' ');
    if (words?.length >= 2) {
      const firstNameInitial = words[0][0].toUpperCase();
      const lastNameInitial = words[words?.length - 1][0].toUpperCase();
      return `${firstNameInitial}${lastNameInitial}`;
    } else if (words?.length === 1) {
      return words[0][0].toUpperCase();
    } else {
      return '';
    }
  };
  const handlePaginationChange = (pageNumber: number, pageSize: number) => {
    let currentPage = pageNumber - 1;
    const pageSizeValue: number = pageSize ?? 1;
    let finalPage = 1;
    if (currentPage > 0) {
      finalPage = currentPage * pageSizeValue;
    } else if (currentPage === 0) {
      finalPage = 0;
    }
    setCurrentPage(pageNumber);
    setPageSize(pageSize);
    getManageLeaveList(searchQuery, finalPage, pageSize);
  };
  const handleEditLeave = ((record: EmployeeRecord) => {
    setIsModalVisible(true)
    setEditRecord(record)

  })
  const columns: ColumnsType<EmployeeRecord> = [
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      width: "30%",

    },
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
      width: "30%",
      render: (text) => (
        <div className='flex items-center leave-type  '>
          <Avatar.Group
            maxCount={3}
            maxPopoverTrigger="click"
            size="large"
            maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf', cursor: 'pointer' }}
          >
            <Avatar className={"leave-type-" + text} >{getLeaveType(text)}</Avatar>
          </Avatar.Group>
          <p className='ml-2'>{text}</p>
        </div>
      ),
    },
    {
      title: 'Total Leaves ',
      dataIndex: 'totalLeaves',
      width: "30%",
      render: (value: any) => <span className="ml-[30px]">{value}</span>,
    },
    {
      title: 'Action',
      dataIndex: 'editButton',
      render: (_, record) => (
        <div className='flex ml-[7px]'>
          <Tooltip placement="top" title="Edit">
            <span className="material-symbols-outlined mr-4 cursor-pointer hover:text-primary" onClick={() => handleEditLeave(record)}>Edit</span>
          </Tooltip>
        </div>
      ),
    },
  ]

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className='leave-management user-table head manage_leaves'>
      <Table columns={columns} dataSource={leaveDataList} pagination={false} loading={loader} />
      <div className='pagination'>
        <Pagination
          className='float-right flex flex-row p-6'
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          current={currentPage === 0 ? 1 : currentPage}
          total={count}
          pageSize={pageSize}
          onChange={handlePaginationChange}
        />
      </div>
      {isModalVisible && <ManageLeaveModal open={isModalVisible} handelClose={handleCancel} editRecord={editRecord} getManageLeaveList={getManageLeaveList} />}
      {/* {loader && <ModalLoader />} */}
    </div>
  )
}

export default ManageLeaveTable;